// extracted by mini-css-extract-plugin
export default {"wrapper":"UspBr","custom-matter-items-holder":"_t86e","active":"n9HPs","switch":"bSbdZ","external-matter-select-holder":"vdKik","wrapper-use-external-matter":"hrmx8"};